/* eslint-disable import/prefer-default-export */
import numeral from 'numeral';
import utils from 'shared/helpers/utils';
import { get } from 'lodash';
// import countryCodes from 'shared/constant/countryCodes';
import {
  switchLanguage, storeTranslation, geti18n, changeLanguageBasedOnParam,
} from './language';
import stepAction from './steps';
import applicantAction from './applicant';
import personalInformation from './personalInformation';
import authAction from './auth';
import idPassportAction from './idPassport';
import fatcaCrsAction from './fatcaCrs';
import { getFormOptions, submitClicked, submitInit } from './formOptions';
import agreementAction from './agreement';
import catalogueAction from './catalogue';

const formatInputVal = (value) => {
  if (!value) return '';

  const number = String(value).replace(/,/g, '');

  if (!/^\d+$/.test(number)) {
    return '';
  }

  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const getUserPayLoad = (getState) => {
  const {
    authReducer: { phoneNumber },
    applicantRootReducer: {
      applicantReducer: {
        applicantId,
        emailSent,
        imarkazRefCode,
        proofOfTransfer,
        paciFrontStatus,
        // applicantPhoneNumbers, email, username, applicantStatus,
      },
      idPassportReducer,
      personalInformationReducer: {
        clientDetails, pep, bankDetails, sourceOfWealth, asi,
        clientProfileForm,
      },
      fatcaCrsReducer: { fatca, crs, countryTax },
    },
    agreementReducer: {
      aofKyc,
      profile,
      ndpf,
      proposedPlan,
      aofKycProfileSignature,
      ndpfProposedPlanSignature,
      aofKycProfileTimestamp,
      ndpfProposedPlanTimestamp,
      aofKycProfileTimestampUTC,
      ndpfProposedPlanTimestampUTC,
    },
  } = getState();

  const pepList = pep.list && pep.list.map(item => ({
    id: item.id,
    name: item.name,
    currentFormerOption: item.currentFormerOption,
    position: item.position,
    otherPosition: item.otherPosition,
    relationship: item.relationship,
  }));

  /** this is to save mobile number if empty */
  if (!clientDetails.mobileNumber || clientDetails.mobileNumber) Object.assign(clientDetails, { mobileNumber: phoneNumber, investedAmount: formatInputVal(clientDetails?.investedAmount) });

  /** Modify format to correct currency (to fix issue on wrong comma) */
  /** @note removed since calculation is done on the app now */
  // if (clientDetails.investedAmount) Object.assign(clientDetails, { investedAmount: numeral(clientDetails.investedAmount).format('0,0') });

  // const parsedCC = typeof asi.poaMobileCC === 'string' ? countryCodes.filter(item => item.isoCode === asi.poaMobileCC).map(item => item.dialCode).toString() : asi.poaMobileCC?.dialCode;
  // asi.poaMobile = `${parsedCC}-${asi.poaMobile}`;

  // const parsedHomeCC = typeof asi.poaHomeNumberCC === 'string' ? countryCodes.filter(item => item.isoCode === asi.poaHomeNumberCC).map(item => item.dialCode).toString() : asi.poaHomeNumberCC?.dialCode;
  // asi.poaHomeNumberCC = `${parsedHomeCC}-${asi.poaHomeNumberCC}`;

  if (idPassportReducer.passportId === null) Object.assign(idPassportReducer, { passportId: '' });

  const modifiedSourceOfWealth = {
    estimatedWealth: formatInputVal(sourceOfWealth.estimatedWealth),
    sourceOfWealthFunds: sourceOfWealth.sourceOfWealthFunds,
    netAssets: sourceOfWealth.netAssets,
    netIncome: formatInputVal(sourceOfWealth.netIncome),
    otherSourceOfWealth: sourceOfWealth.otherSourceOfWealth,
    sourceOfWealthFundsDetails: JSON.stringify({
      totalYearOfExp: get(sourceOfWealth, 'totalYearOfExp'),
      detailsOfRelationShip: get(sourceOfWealth, 'detailsOfRelationShip'),
      yearOfInheritance: get(sourceOfWealth, 'yearOfInheritance'),
      approxValueOfInherited: get(sourceOfWealth, 'approxValueOfInherited') ? numeral(sourceOfWealth?.approxValueOfInherited).format('0,0') : '',
      typesOfAssetsAndMarkets: get(sourceOfWealth, 'typesOfAssetsAndMarkets'),
      approxValueOfInvestmentsAndSavings: get(sourceOfWealth, 'approxValueOfInvestmentsAndSavings') ? numeral(sourceOfWealth?.approxValueOfInvestmentsAndSavings).format('0,0') : '',
      detailsOfBusinessName: get(sourceOfWealth, 'detailsOfBusinessName'),
      typeOfActivity: get(sourceOfWealth, 'typeOfActivity'),
      approxValueOfRevenues: get(sourceOfWealth, 'approxValueOfRevenues') ? numeral(sourceOfWealth?.approxValueOfRevenues).format('0,0') : '',
    }),
    estimatedWealthApproxValue: sourceOfWealth?.estimatedWealthApproxValue ? numeral(sourceOfWealth?.estimatedWealthApproxValue).format('0,0') : '',
    netIncomeApproxValue: sourceOfWealth?.netIncomeApproxValue ? numeral(sourceOfWealth?.netIncomeApproxValue).format('0,0') : '',
  };

  const data = {
    proofOfTransfer,
    /** only send when set, so it won't overwrite the saved status with null */
    ...(paciFrontStatus && { paciFrontStatus }),
    imarkazRefCode,
    idAndPassport: { ...idPassportReducer, tobeEmailed: idPassportReducer.tobeEmailed === 'tobeEmailed' },
    clientDetails,
    pep: { ...pep, list: pepList },
    bankDetails,
    sourceOfWealth: modifiedSourceOfWealth,
    authorizedSignatoryInformation: asi,
    clientProfileForm,
    fatca,
    crs,
    id: applicantId,
    countryTax,
    agreements: {
      aofKyc: aofKyc.agreements,
      profile: profile.agreements,
      ndpf,
      proposedPlan,
      aofKycProfileSignature,
      ndpfProposedPlanSignature,
      aofKycProfileTimestamp,
      ndpfProposedPlanTimestamp,
      aofKycProfileTimestampUTC,
      ndpfProposedPlanTimestampUTC,
    },
    nextInstruction: {
      emailSent,
    },
  };

  /** Modify data to add investment experience */
  const modifiedData = utils.investmentExp(data);

  return modifiedData;
};

const loadStateAction = stateFile => ({
  type: 'LOAD_STATE',
  stateFile,
});

export {
  getUserPayLoad,
  switchLanguage, storeTranslation, geti18n, changeLanguageBasedOnParam,

  getFormOptions,
  submitClicked, submitInit,

  stepAction,
  authAction,

  applicantAction,
  personalInformation,
  idPassportAction,
  fatcaCrsAction,

  agreementAction,

  loadStateAction,

  catalogueAction,
};
